import React                        from 'react';
import Dialog                       from '@material-ui/core/Dialog';
import DialogContentText            from '@material-ui/core/DialogContentText';
import DialogContent                from '@material-ui/core/DialogContent';
import { useTranslation }           from 'react-i18next';
import DialogTitle                  from '@material-ui/core/DialogTitle';
import DialogActions                from '@material-ui/core/DialogActions';
import PropTypes                    from 'prop-types';
import { useHistory }               from 'react-router';
import { getCustomOsRoute }         from '../../RouteController/Factory';
import Button                       from '../../core/input/Button';
import RichAlertTrans               from '../../core/feedback/RichAlertTrans';
import { useOperatingSystemDelete } from '@karpeleslab/klb-react-services';

const DeleteDialog = ({ os, open, setOpen }) => {
	const { t } = useTranslation();
	const [deleteOs, deleting] = useOperatingSystemDelete(os.Shell_OS__);
	const history = useHistory();

	const handleClose = () => {
		setOpen(false);
	};

	const handleDelete = e => {
		e.preventDefault();

		deleteOs()
			.then(handleClose)
			.then(() => history.push(getCustomOsRoute()));
	};

	return (
		<Dialog
			open={open}
			aria-labelledby={t('dialog_delete_os_title')}
			aria-describedby={t('dialog_delete_os_title')}
		>
			<DialogTitle id='delete-os-title'>
				{t('dialog_delete_os_title')}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id='delete-os-description'>
					<RichAlertTrans
						severity='warning'
						i18nKey='dialog_delete_os_description'
						values={{ label: os?.Name }}
					/>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					color='default'
					onClick={handleClose}
					disabled={deleting}
				>
					{t('close_btn')}
				</Button>
				<Button
					onClick={handleDelete}
					color='secondary'
					variant='outlined'
					disabled={deleting}
					loading={deleting}
				>
					{t('delete_btn')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteDialog;

DeleteDialog.propTypes = {
	os: PropTypes.object,
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired
};
